export const normalizeProjectName = value => value?.trim().toLowerCase() || "";

export const buildDuplicateProjectNameCounts = projects =>
  projects.reduce((memo, project) => {
    const key = normalizeProjectName(project?.name);
    if (!key) return memo;
    memo[key] = (memo[key] || 0) + 1;
    return memo;
  }, {});

export const shouldShowProjectClientName = (project, duplicateNameCounts = {}) => {
  const key = normalizeProjectName(project?.name);
  return Boolean(key) && duplicateNameCounts[key] > 1;
};

export const getProjectClientLabel = (
  project,
  duplicateNameCounts = {},
  forceShowClientName = false
) => {
  const clientName = project?.client?.name;
  if (!clientName) return "";
  if (forceShowClientName || shouldShowProjectClientName(project, duplicateNameCounts)) {
    return clientName;
  }
  return "";
};

export const getProjectOptionLabel = (
  project,
  duplicateNameCounts = {},
  forceShowClientName = false
) => {
  if (!project?.name) return "";
  const clientLabel = getProjectClientLabel(
    project,
    duplicateNameCounts,
    forceShowClientName
  );
  return clientLabel ? `${project.name} - ${clientLabel}` : project.name;
};
